import { render, staticRenderFns } from "./AuthorizationInfo.vue?vue&type=template&id=44754ddf&scoped=true&"
import script from "./AuthorizationInfo.vue?vue&type=script&lang=js&"
export * from "./AuthorizationInfo.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationInfo.vue?vue&type=style&index=0&id=44754ddf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44754ddf",
  null
  
)

export default component.exports